<ng-container *ngIf="type=='sending' || type=='calculate'">

    <div class="special-loading__container">
        <div class="special-loading">
            <div class="special-loading__circle" [attr.data-content]="message|translate">
                <div class="tw-w-full tw-overflow-hidden tw-h-full special-loading__img">
                    <img class="" [src]="imgSrc" [style.maxWidth]="imgMaxWidth">
                </div>
                <div class="special-loading__outline" [class]="'special-loading__outline--'+borderColor">
                </div>
            </div>

        </div>
    </div>

</ng-container>

<!-- pishgam -->
<ng-container *ngIf="type=='pishgamSending' || type=='pishgamCalculate'">

    <div class="special-loading__container">
        <div class="special-loading">
            <div class="pishgam-special-loading__circle" [attr.data-content]="message|translate">
                <div class="tw-w-full tw-overflow-hidden tw-h-full special-loading__img ">
                    <img class="" [src]="imgSrc" [style.maxWidth]="imgMaxWidth">
                </div>
            </div>

        </div>
    </div>

</ng-container>